import systemNotificationsAPI from '@shared/api/systemNotifications'

import { NOTIFICATION } from '@shared/config/constants'

export default function useSystemNotifications() {
  function getMessageSeverity(notificationSeverity) {
    const notificationMapper = {
      INFORMATION: NOTIFICATION.INFO,
      ERROR: NOTIFICATION.ERROR,
      WARNING: NOTIFICATION.WARNING,
      SUCCESS: NOTIFICATION.SUCCESS,
    }
    return notificationMapper[notificationSeverity] || NOTIFICATION.INFO
  }

  async function getSystemNotifications(language) {

    try {
      const response = await systemNotificationsAPI.getSystemNotifications({ language })

      return response.map(notification => {
        return {
          ...notification,
          level: getMessageSeverity(notification.level),
        }
      })
    } catch (error) {
      console.error(`Can't fetch notifications: ${error}`)
    }
  }

  return {
    getSystemNotifications,
  }
}
